import * as React from 'react'

import {cn} from '@/lib/utils'

export type SelectProps = React.InputHTMLAttributes<HTMLSelectElement> & {
    className?: string
    'data-testid'?: string | undefined
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
    ({className, children, 'data-testid': dataTestId, ...props}, ref) => {
        return (
            <select
                data-testid={dataTestId || 'Select'}
                className={cn(
                    'relative h-[3.1875rem] pl-2.5 pr-9 pt-[1.5625rem] pb-0 font-grotesque font-light body-md border-0 border-b border-solid border-btn-secondary-text rounded-none bg-transparent focus-visible:outline-none focus-visible:shadow-[0_1px_5px_0_rgba(55,_84,_129,_0.5)] focus-visible:border focus-visible:border-primary-focus-shadow focus-visible:border-b-[#7493c4] focus-visible:rounded-[6px_6px_0_0] appearance-none bg-no-repeat bg-[length:0.8125rem_0.5rem] bg-[calc(100%_-_0.5625rem)_1.25rem]',
                    className
                )}
                style={{
                    backgroundColor: 'transparent',
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='6' viewBox='0 0 12 6' fill='%23142745' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.9544 5.99852C5.8056 5.98772 5.6652 5.92894 5.5536 5.83054L0.220768 1.13738C0.0443674 0.981381 -0.0348329 0.744986 0.0143673 0.516989C0.0635676 0.288992 0.233968 0.104204 0.460769 0.0322048C0.686371 -0.0397943 0.935972 0.0118045 1.11237 0.166603L6 4.46975L10.8876 0.166603C11.064 0.0106045 11.3136 -0.0397943 11.5392 0.0322048C11.7672 0.104204 11.9352 0.288992 11.9856 0.516989C12.0348 0.744986 11.9556 0.981381 11.7792 1.13738L6.4464 5.83171C6.312 5.94931 6.1344 6.01052 5.9544 5.99852V5.99852Z'/%3E%3C/svg%3E")`
                }}
                ref={ref}
                {...props}
            >
                {children}
            </select>
        )
    }
)
Select.displayName = 'Select'

export {Select}
